import React from 'react';

import Grid from '~/components/core/Atomic/Grid/Grid';
import Typography from '~/components/core/Atomic/Typography';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  className?: string;
  /** Subtitles that carry a rule rather than a hint need full-contrast text, not the caption grey. */
  subtitleClassName?: string;
}

const SectionHeading: React.FC<SectionHeadingProps> = ({ title, subtitle, className, subtitleClassName }) => {
  return (
    <Grid item xs={12} className={className}>
      <Typography variant="subtitle1">{title}</Typography>
      {subtitle && (
        <Typography variant="caption" className={subtitleClassName}>
          {subtitle}
        </Typography>
      )}
    </Grid>
  );
};

export default SectionHeading;
